import { notification } from 'antd';
import { Dispatch } from '@reduxjs/toolkit';
import { ResponseError } from '../../custom_types/common';
import { HTTP_ERROR_CODE_MESSAGE } from '../utils/constants';
import { logoutUserHandler } from '../../redux/user/userSlice';

const errorHandler = (error: ResponseError, dispatch: Dispatch): void => {
  const { response } = error;
  if (response && response.status) {
    let errorText = HTTP_ERROR_CODE_MESSAGE[response.status] || response.statusText;
    const { status, url } = response;

    if (
      response.data &&
      response.data.error &&
      response.data.error.message &&
      response.data.error.message.code
    ) {
      if (response.data.error.message.code === 11000) {
        errorText = `${Object.values(response.data.error.message.keyValue)[0]} 已存在！`;
      }
    }

    if (status === 401) {
      dispatch(logoutUserHandler());
      notification.error({
        message: '登录超时',
        description: '已登出'
      });
    }

    // if (status === 500) {
    //   dispatch()
    // }
  }
  if (!response) {
    notification.error({
      description: '您的网络发生异常，无法连接服务器',
      message: '网络异常'
    });
  }
};

export default errorHandler;
